import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { StoreNotesCardProps } from '../types/StoreNotesCardProps';
import '../../../common/action-required-card/components/ActionRequiredCard.scss';

export default function PostInstallCallCard(props: StoreNotesCardProps) {

    const navigate = useNavigate();
    const count = props.statData.find(x => x.statID === props.statID)?.total ?? 0;

    return (
        <div className='ar-button dx-card post-install'>
            <div className='ar-text ar-text-multiline'>Post-Install Calls</div>
            <div className='ar-total'>
                <span>{count}</span>
            </div>
            <div className='button-replacement'>
            </div>
            <Button onClick={() => navigate(props.url)}>
                Complete Post-Install Calls
            </Button>
        </div>
    )
} 
